module.exports = __webpack_public_path__ + "images/柏纳s长图_08-4.jpg?v=0f16baac";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_08-4.jpg
 ** module id = 170
 ** module chunks = 1 2
 **/